exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1EVaFmc7L74JFKKe10SReH{display:-webkit-box;display:-ms-flexbox;display:flex;color:\"[theme:neutralPrimary, default:#333333]\";-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}html[dir] ._1EVaFmc7L74JFKKe10SReH{border-bottom:1px solid \"[theme:neutralTertiaryAlt, default:#c8c8c8]\";padding-bottom:10px;margin-bottom:5px}._3qEJOimMnGxNBTbgFv2xtR{-webkit-box-flex:1;-ms-flex:1;flex:1}._3ScqS9OWOV1oXwG0PxwIH0{color:\"[theme:themePrimary, default:#0078D4]\"}", ""]);

// exports
exports.locals = {
	"container": "_1EVaFmc7L74JFKKe10SReH",
	"resetButton": "_3qEJOimMnGxNBTbgFv2xtR",
	"enableFlightsButton": "_3ScqS9OWOV1oXwG0PxwIH0"
};